"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrefundedDrawContributionMessageForEmail = exports.getPrefundedDrawContribution = void 0;
const lodash_1 = __importDefault(require("lodash"));
const utils_1 = require("../utils");
// Works out to: receivable advance + cash advance - principal balance
const getPrefundedDrawContribution = ({ cashAdvanceRate, collectionsRecycleTotalAmount, currentPrincipalBalance, drawRequestTotalAmount, totalMaxAdvanceAmount, }) => {
    const maxSecuredDrawRequestAmount = lodash_1.default.round(totalMaxAdvanceAmount -
        currentPrincipalBalance -
        collectionsRecycleTotalAmount * cashAdvanceRate, 2);
    const roundedDrawRequestTotalAmount = lodash_1.default.round(drawRequestTotalAmount, 2);
    const prefundedDrawContribution = lodash_1.default.round(roundedDrawRequestTotalAmount - maxSecuredDrawRequestAmount, 2);
    if (roundedDrawRequestTotalAmount > 0 && prefundedDrawContribution > 0) {
        return prefundedDrawContribution;
    }
    return 0;
};
exports.getPrefundedDrawContribution = getPrefundedDrawContribution;
const getPrefundedDrawContributionMessageForEmail = ({ prefundedDrawContribution, }) => {
    let prefundedDrawContributionMessage;
    if (prefundedDrawContribution > 0) {
        const formattedPrefundedDrawContribution = (0, utils_1.numberToCurrencyWithSymbol)({
            number: prefundedDrawContribution,
        });
        prefundedDrawContributionMessage = `(includes prefunded draw\nof ${formattedPrefundedDrawContribution})`;
    }
    return prefundedDrawContributionMessage;
};
exports.getPrefundedDrawContributionMessageForEmail = getPrefundedDrawContributionMessageForEmail;
//# sourceMappingURL=index.js.map